// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Title_wrapper__n1sXn","title":"Title_title__SAC_l","value":"Title_value__7qzpi"};